import { FC, memo, PropsWithChildren } from "react";
import "./panel-header.scss";

interface PanelHeaderProps extends PropsWithChildren {
  variant?:
    | "white"
    | "success"
    | "default"
    | "danger"
    | "info"
    | "warning"
    | "close"
    | "icon"
    | "cancel";
  className?: string;
  style?: React.CSSProperties;
}

const PanelHeaderComponent: FC<PanelHeaderProps> = ({
  className,
  variant = "white",
  children,
  style,
}) => {
  return (
    <div style={style} className={`panel-header ${className} ${variant}`}>
      {children}
    </div>
  );
};

export const PanelHeader = memo(PanelHeaderComponent);
export { PanelActionArea } from "./panel-action-area";
export { PanelTitle } from "./panel-title";
export { PanelSubTitle } from "./panel-sub-title";
export { PanelDescription } from "./panel-description";
export { PanelTitleArea } from "./panel-title-area";
